<div class="highlighs-container">
  <div class="card-sale">
    <h3 class="card-title">{{ highlighsPath + "1.title" | translate }}</h3>
    <h2 class="card-text">{{ highlighsPath + "1.text" | translate }}</h2>
  </div>

  <div class="card-asset">
    <h3 class="card-title">{{ highlighsPath + "2.title" | translate }}</h3>
    <h2 class="card-text">{{ highlighsPath + "2.text" | translate }}</h2>
  </div>

  <div class="card-stacking">
    <h3 class="card-title">{{ highlighsPath + "3.title" | translate }}</h3>
    <h2 class="card-text">{{ highlighsPath + "3.text" | translate }}</h2>
  </div>

  <div class="card-features">
    <h3 class="card-title">{{ highlighsPath + "4.title" | translate }}</h3>
    <p class="card-text">
      <span>{{ highlighsPath + "4.text" | translate }}</span>
      <a
        (click)="openClubFii()"
        *ngIf="
          currentCode == 'br' && (browserLang === 'en' || browserLang === 'pt')
        "
        class="card-text link-blue btn-decoration"
      >
        {{ highlighsPath + "4.text1" | translate }}
        <span
          *ngIf="
            currentCode == 'br' &&
            (browserLang === 'en' || browserLang === 'pt')
          "
          class="card-text"
        >
          {{ highlighsPath + "4.text2" | translate }}
        </span>
      </a>
    </p>
  </div>
</div>
